import { useContext } from "react";
import { SocketContext } from "../../../context";
import { useProposedSolutionCards, useSound } from "../../../hooks";
import { PlayersSolutionCardsMolecule } from "../../molecules";

const SolutionSelectedByDilemmaOwner = () => {
    const { theSolutionCardSelectedByDilemmaOwner } = useContext(SocketContext);
    const [proposedSolutionCardsArray] = useProposedSolutionCards();
    const {playSound} = useSound();
    const cardDimentions = {width: `30vh`, height: `40vh`};
    const solutionCardThatDilemmaPicked : any = proposedSolutionCardsArray.find((solutionCard: any) => theSolutionCardSelectedByDilemmaOwner === solutionCard?.card?.id );

    return(
        <div className={`solutions_proposed_card solution_card_that_dilemma_owner_selected` } onMouseEnter={() => playSound("/sounds/ItemHover.mp3")} >
            <PlayersSolutionCardsMolecule selectedCard={solutionCardThatDilemmaPicked} cardDimentions={cardDimentions} />
        </div>
    )
}

export default SolutionSelectedByDilemmaOwner;